module.exports = {"pageTitleText":"通知對象","createText":"新增","channelName":"名稱","channelType":"類型","channelTelegramBotToken":"Bot Token","channelLineBotToken":"Channel Access Token","channelSendTo":"發送地址","channelTest":"測試","sections":{"essential":"基礎","advanced":"進階"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/notificationChannels.json
// module id = GKXb
// module chunks = 3